import * as React from 'react';

import * as styles from './HintQuestions.css';

export const HintQuestions: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
  return <div className={styles['hints-container']}>{children}</div>;
};
